import { useAppDispatch, useAppSelector } from 'application/hooks/redux';
import { setPolicyType } from 'application/store/reducers/AgreementsAndPolicies/agreementsAndPoliciesSlice';
import { AgreementAndPolicyType } from 'application/store/reducers/AgreementsAndPolicies/models';

export const useAgreementsAndPoliciesModal = () => {
  const dispatch = useAppDispatch();
  const { policyType } = useAppSelector((state) => state.agreementsAndPolicies);

  const openCookiesModal = () => {
    dispatch(setPolicyType(AgreementAndPolicyType.COOKIES));
  };
  const openPrivacyPolicyModal = () => {
    dispatch(setPolicyType(AgreementAndPolicyType.PRIVACY_POLICY));
  };
  const openTermsAndConditionsModal = () => {
    dispatch(setPolicyType(AgreementAndPolicyType.TERMS_AND_CONDITIONS));
  };
  const closeModal = () => {
    dispatch(setPolicyType(null));
  };
  const isModalOpen = policyType !== null;
  return {
    isModalOpen,
    policyType,
    closeModal,
    openCookiesModal,
    openPrivacyPolicyModal,
    openTermsAndConditionsModal,
  };
};
